<style lang="scss" scoped>
.shop-block {
  width: 100%;
  overflow: hidden;
  height: 1300px;

  .wrapper {
    display: flex;

    @include margin-x(auto);
    width: map_get($container, xl);

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .content-block {
        display: flex;
        height: 620px;
        min-width: 400px;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 150px;

        &:first-child {
          padding-bottom: 90px;
          margin-bottom: 50px;
        }

        .title {
          font-size: 40px;
          font-weight: 500;
          line-height: 1.15;
        }

        .title {
          margin-bottom: 60px;
          display: flex;
          align-items: center;

          span {
            font-size: 28px;
            font-weight: 500;
          }
        }

        .subtitle {
          font-weight: 500;
          font-size: 40px;
          line-height: 47px;
          color: #F5F5F7;
          white-space: nowrap;
        }

        .link {
          font-size: 20px;
          color: $link-color-blue;

          &:after {
            content: '→';
            font-family: Arial, Helvetica;
            margin-left: 5px;
          }

          &:hover {
            color: $link-hover-color-blue;
          }

          &:active {
            color: $link-active-color-blue;
          }

          [dir=rtl] & {
            &:after {
              content: none;
            }

            &:before {
              content: '←';
              margin-left: 0;
              margin-right: 5px;
            }
          }
        }

        .text {
          margin-top: 20px;
          font-size: 22px;
          line-height: 32px;
          color: #C3C3C3;
          margin-bottom: 20px;

          & > .white {
            color: #F5F5F7;
          }
        }

        [dir=rtl] & {
          text-align: right;
        }
      }
    }

    .images-wrapper {
      flex: 1 1 780px;
      max-width: 780px;
      margin-right: 60px;
      position: relative;

      .images {
        position: absolute;
        top: 0;
        margin-left: -30px;

        &.fixed {
          width: map_get($container, xl);
          position: fixed;
        }

        &.bottom {
          top: 680px;
        }

        .image {
          position: absolute;
          transition: 400ms linear;
          transform-origin: left top;
          overflow: hidden;
          border-radius: 5px;

          .img {
            width: 100%;
            height: 100%;
            transition: 400ms linear;
            position: absolute;
            top: 0;
            left: 0;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            transform-origin: left top;

            &.from {
              opacity: 1;
            }

            &.to {
              opacity: 0;
            }
          }

          &.to {
            .img {
              &.from {
                opacity: 0;
              }

              &.to {
                opacity: 1;
              }
            }
          }

          @mixin from-to($w, $h, $top, $left, $w2, $h2, $top2, $left2) {
            top: $top + 0px;
            left: $left + 0px;
            width: $w + 0px;
            height: $h + 0px;

            $scaleX: $w2/$w;
            $scaleY: $h2/$h;
            $moveX: $left2 - $left;
            $moveY: $top2 - $top;

            .img {
              &.from {
                width: $w + 0px;
                height: $h + 0px;
              }

              &.to {
                width: $w2 + 0px;
                height: $h2 + 0px;

                transform: scale(1.2, 1.2);
              }
            }

            &.to {
              .img {
                &.from {
                  // transform: scale($scaleX, $scaleY);
                }

                &.to {
                  transform: scale(1/$scaleX, 1/$scaleY);
                }
              }

              transform: translate($moveX + 0px, $moveY + 0px) scale($scaleX, $scaleY);
            }
          }

          &.image-1 {
            @include from-to(394, 348, 0, 412, 514, 369, 0, 292);
          }

          &.image-2 {
            @include from-to(280, 162, 37, 143, 240, 168, 37, 30);
          }

          &.image-3 {
            @include from-to(195, 106, 227, 205, 181, 168, 226, 233);
          }

          &.image-4 {
            @include from-to(184, 162, 216, 0, 114, 100, 254, 81);
          }

          &.image-5 {
            @include from-to(416, 226, 395, 75, 399, 200, 420, 40);
          }

          &.image-6 {
            @include from-to(270, 238, 326, 518, 316, 245, 319, 472);
          }
        }
      }
    }

    [dir=rtl] & {
      direction: ltr;
    }
  }
}
</style>

<template>
  <div class="shop-block" id="shop-block" ref="container">
    <div class="wrapper">
      <div class="images-wrapper">
        <div
          class="images"
          :style="wrapper.styles"
          :class="wrapper.classes">
          <div
            v-for="i in 6"
            ref="img"
            :key="i"
            class="image"
            :class="{[`image-${i}`]: true, to: imagesTo}">
            <div
              class="img from"
              :style="{backgroundImage: `url(${baseUrl}images/blocks/shop-block/${i}f.jpg)`}"></div>
            <div
              class="img to"
              :style="{backgroundImage: `url(${baseUrl}images/blocks/shop-block/${i}m.jpg)`}"></div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-block">
          <div class="subtitle">{{ $t('freeGames') }}</div>
          <div class="text" v-html="$t('freeGamesText', {freeGames: parseInt(this.freeGames / 10, 10) * 10 })"></div>
          <a class="link" :href="freeGamesUrl">
            <span>{{ $t('link') }}</span>
          </a>
        </div>
        <div class="content-block">
          <div class="subtitle">{{ $t('shop') }}</div>
          <div class="text" v-html="$t('shopText', {paidGames: parseInt(this.paidGames / 10, 10) * 10})"></div>
          <a class="link" :href=payableGamesUrl>
            <span>{{ $t('link') }}</span>
          </a>
        </div>
        <div class="content-block">
          <div class="subtitle">{{ $t('shop') }}</div>
          <div class="text" v-html="$t('shopText', {paidGames: parseInt(this.paidGames / 10, 10) * 10})"></div>
          <a class="link" :href=payableGamesUrl>
            <span>{{ $t('link') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShopBlock',
  i18n: {
    messages: {
      ru: {
        play: 'Играйте',
        freeGames: 'Бесплатные игры',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Более {freeGames} игр<span class="tooltip">В вашем регионе могут быть доступны не все игры</span></b> представлены на&nbsp;площадке.',
        shop: 'Платные игры',
        link: 'Перейти',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Более {paidGames} игр<span class="tooltip">В вашем регионе могут быть доступны не все игры</span></b> от ведущих мировых издателей и разработчиков.',
      },
      en: {
        play: 'Play',
        freeGames: 'Free-to-Play Games',
        freeGamesText:
          'From planet-hopping adventures in the depths of space to daring conquests of medieval worlds, immerse yourself in over <b class="bold-light has-tooltip" flow="up">{freeGames} free games!<span class="tooltip">Some games might be unavailable in your region.</span></b>',
        shop: 'VK Play',
        link: 'Explore',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">{paidGames}+ games<span class="tooltip">Some games might be unavailable in your region</span></b> from the world’s finest gaming studios are ready to play.',
      },
      de: {
        play: 'Spielen',
        freeGames: 'Free-to-Play',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Mehr als {freeGames} Spiele<span class="tooltip">Einige Spiele sind in deiner Region eventuell nicht verfügbar</span></b> auf der Plattform verfügbar.',
        shop: 'VK Play',
        link: 'Los',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Mehr als {paidGames} Spiele<span class="tooltip">Einige Spiele sind in deiner Region eventuell nicht verfügbar</span></b> von den weltweit führenden Publishern und Entwicklern.',
      },
      fr: {
        play: 'Jouez',
        freeGames: 'Gratuits',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Plus de {freeGames} jeux vous<span class="tooltip">Il se peut que certains jeux soient indisponibles dans votre région</span></b> attendent sur la plateforme.',
        shop: 'Magasin de jeux',
        link: 'Accéder',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Plus de {paidGames} jeux<span class="tooltip">Il se peut que certains jeux soient indisponibles dans votre région</span></b> des meilleurs développeurs et éditeurs du monde entier.',
      },
      es: {
        play: 'Jugar',
        freeGames: 'Juego gratuito',
        freeGamesText:
          'Te esperan <b class="bold-light has-tooltip" flow="up">más de {freeGames} juegos<span class="tooltip">Puede que algunos juegos no estén disponibles en tu región</span></b> en la plataforma.',
        shop: 'Tienda',
        link: 'Ir Tienda',
        shopText:
          'Hay <b class="bold-light has-tooltip" flow="up">más de {paidGames} juegos<span class="tooltip">Puede que algunos juegos no estén disponibles en tu región</span></b> de las mejores empresas y desarrolladoras del mundo.',
      },
      tr: {
        play: 'Oyna',
        freeGames: 'Oynaması ücretsiz',
        freeGamesText:
          'Platformda <b class="bold-light has-tooltip" flow="up">{freeGames}\'den fazla oyun<span class="tooltip">Bazı oyunlar bölgende uygun olmayabilir.</span></b> var',
        shop: 'Game Store',
        link: 'Git',
        shopText:
          'Dünyaca ünlü yayıncılar ve geliştiricilerden <b class="bold-light has-tooltip" flow="up">{paidGames}\'den fazla oyun<span class="tooltip">Bazı oyunlar bölgende uygun olmayabilir.</span></b>',
      },
      pl: {
        play: 'Graj',
        freeGames: 'Darmowe',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Ponad {freeGames} gier<span class="tooltip">Niektóre gry mogą nie być dostępne w twoim regionie</span></b> dostępnych na platformie.',
        shop: 'Sklep gier',
        link: 'Idź',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Ponad {paidGames} gier<span class="tooltip">Niektóre gry mogą nie być dostępne w twoim regionie</span></b> od wiodących na świecie producentów oraz twórców.',
      },
      ar: {
        play: 'لعب',
        freeGames: 'ألعاب مجانية',
        freeGamesText:
          '<span>من مغامرات التنقل بين الكواكب في أعماق الفضاء حتى غزوات العصور الوسطى </span> <b class="bold-light has-tooltip" flow="up">،لعبة مجانية {freeGames}<span class="tooltip">قد لا تكون بعض الألعاب متوفرة في منطقتك</span></b> اغمر نفسك في أكثر من',
        shop: 'متجر VK Play',
        link: 'استكشاف',
        shopText:
          '<span>الاستوديوهات العالمية لتطوير الألعاب جاهزة للعب</span> <b class="bold-light has-tooltip" flow="up">لعبة {paidGames}<span class="tooltip">قد لا تكون بعض الألعاب متوفرة في منطقتك</span></b> أكثر من',
      },
    },
  },
  props: {
    scrollTop: {
      type: Number,
      default: 0,
    },
    freeGames: {
      type: Number,
      default: 0,
    },
    paidGames: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      containerTop: 0,
      containerBottom: 0,

      topOffset: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.containerTop = window.pageYOffset + this.$refs.container.getBoundingClientRect().top;
      this.containerBottom = window.pageYOffset + this.$refs.container.getBoundingClientRect().bottom;

      this.topOffset = Math.round(window.innerHeight * 1.5 / 10);
    }, 500);
  },
  computed: {
    wrapper() {
      const styles = {};

      const classes = {
        fixed: false,
        bottom: this.scrollTop > this.containerBottom - (620 + this.topOffset),
      };

      classes.fixed = this.scrollTop > this.containerTop - this.topOffset && !classes.bottom;

      if (classes.fixed) {
        styles.top = `${this.topOffset}px`;
      }

      return {
        classes,
        styles,
      };
    },

    imagesTo() {
      return this.scrollTop && this.scrollTop > this.containerTop + 200;
    },
    freeGamesUrl() {
      return '//vkplay.ru/play/is_free/';
    },
    payableGamesUrl() {
      return '//vkplay.ru/play/is_sellable/';
    },
  },
};

</script>
